// @flow

// Libs
import { connect } from 'react-redux'

// Component
import HeftyMap from '../components/HeftyMap'

// Selectors
import { farmsById$ } from 'hfty-assets-dom'
import fieldsBbox$ from 'hfty-map/src/selectors/fieldsBbox'
import fieldsToRenderOnMap$ from 'hfty-map/src/selectors/fieldsToRenderOnMap'
import { calcGrid$ } from 'hfty-grid'
import mapModule$ from 'hfty-map-dom/src/selectors/mapModule'

// hfty-map
import {
  // Selectors
  selectedField$,
  selectedFieldId$,
  selectedFieldIdNotValidated$,
  selectedSeasonId$,
  selectedFarmIdNotValidated$,
  selectedFeatureIndex$,
  hoverFeatureIndex$,
  featureOperation$,
  selectedMapType$,
  panelToggled$,

  // Action Creators
  centerMapDefault,
  centerMapToFarm,
  centerMapToField,
  togglePanel,
  selectFeature,
  toggleHoverFeature,
} from 'hfty-map'
import featureOperator from 'hfty-map/src/featureOperator'

import { changeBaseLayer } from 'hfty-map/src/actions'

import soilJobsOperator from 'fc-operator-sampling-jobs'

import { default as jobOperations$ } from 'hfty-soil-jobs-dom/src/selectors/operations'

// Action Creators
import { setMapZoom, setMapRef, clearMapRef, fitMapBounds, flyTo, setView } from 'fc-redux-leaflet'

const mapStateToProps = (state: Object): Props => ({
  farms: farmsById$(state),
  fieldsToRenderOnMap: fieldsToRenderOnMap$(state),
  fieldsBbox: fieldsBbox$(state),
  selectedField: selectedField$(state),
  selectedFieldId: selectedFieldId$(state),
  selectedFieldIdNotValidated: selectedFieldIdNotValidated$(state),
  selectedSeasonId: selectedSeasonId$(state),
  selectedFarmIdNotValidated: selectedFarmIdNotValidated$(state),
  selectedFeatureIndex: selectedFeatureIndex$(state),
  hoverFeatureIndex: hoverFeatureIndex$(state),
  featureOperation: featureOperation$(state),
  selectedMapType: selectedMapType$(state),
  gridData: calcGrid$(state),
  panelToggled: panelToggled$(state),
  jobOperations: jobOperations$(state),
  mapModule: mapModule$(state),
})

type MapDispatchToProps = {
  setMapRef: Function,
  clearMapRef: Function,
  fitMapBounds: Function,
  setMapZoom: Function,
  togglePanel: Function,
  changeBaseLayer: Function,
  centerMapDefault: Function,
  centerMapToFarm: Function,
  centerMapToField: Function,
}

const mapDispatchToProps: MapDispatchToProps = {
  setMapRef,
  clearMapRef,
  fitMapBounds,
  setMapZoom,
  changeBaseLayer,
  togglePanel,
  flyTo,
  setView,
  centerMapDefault,
  centerMapToFarm,
  centerMapToField,
  onSelectFeature: selectFeature,
  onToggleHoverFeature: toggleHoverFeature,
  onSubmitEditSelectedField: featureOperator.actionCreators.submitOperation,
  onCancelEditSelectedField: featureOperator.actionCreators.cancelOperation,
  onChangeEditSelectedField: featureOperator.actionCreators.updateOperation,
  onCancelJob: soilJobsOperator.actionCreators.cancelOperations,
}

export default connect(mapStateToProps, mapDispatchToProps)(HeftyMap)
